import { createStyles, makeStyles } from "@material-ui/core";
import { JobCandidateStatus } from "../../domain";
import * as React from "react";

import {
    HiredStatusBadge,
    InterviewStatusBadge,
    NewStatusBadge,
    OfferedStatusBadge,
    QualifyingStatusBadge,
    RejectedStatusBadge,
    ReviewStatusBadge,
    SubmittedStatusBadge,
} from "../../assets/statusBadges";
import { RelodeTheme } from "../styles";

const useStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        root: {},
    })
);

export interface StatusLabelProps {
    jobCandidateStatus: number | JobCandidateStatus;
    id?: string;
    className?: string;
    title?: string;
}

export const StatusLabel = (props: StatusLabelProps) => {
    const { jobCandidateStatus, ...rest } = props;

    const status =
        jobCandidateStatus instanceof JobCandidateStatus
            ? jobCandidateStatus
            : JobCandidateStatus.fromId(jobCandidateStatus);
    switch (status) {
        case JobCandidateStatus.New:
            return <NewStatusBadge {...rest} />;
        case JobCandidateStatus.Qualifying:
            return <QualifyingStatusBadge {...rest} />;
        case JobCandidateStatus.Review:
            return <ReviewStatusBadge {...rest} />;
        case JobCandidateStatus.Submitted:
            return <SubmittedStatusBadge {...rest} />;
        case JobCandidateStatus.Interviewing:
            return <InterviewStatusBadge {...rest} />;
        case JobCandidateStatus.Offered:
            return <OfferedStatusBadge {...rest} />;
        case JobCandidateStatus.Hired:
            return <HiredStatusBadge {...rest} />;
        case JobCandidateStatus.Rejected:
            return <RejectedStatusBadge {...rest} />;
        default:
            return null;
    }
};
